async function firstSuccessful(promises) {
    if (promises.length === 0)
        return null;
    return new Promise((resolve) => {
        let rejections = 0;
        promises.forEach((promise) => {
            promise.then(resolve).catch(() => {
                rejections += 1;
                if (rejections === promises.length)
                    resolve(null);
            });
        });
    });
}
export const shortenAddress = (address, len = 4) => {
    if (!address)
        return '';
    const str = address.toString();
    if (str.startsWith('0x'))
        return `${str.slice(0, len + 2)}...${str.slice(-len)}`;
    else
        return `${str.slice(0, len)}...${str.slice(-len)}`;
};
export const subAddress = (address) => {
    if (!address)
        return '';
    const str = address.toString();
    if (str.startsWith('0x'))
        return `${str.slice(0, 6)}`;
    else
        return `${str.slice(0, 4)}`;
};
export const getFastestRpc = async (rpcs, callback) => {
    if (typeof rpcs == 'string') {
        return callback(rpcs)
            .then(() => rpcs)
            .catch(() => null);
    }
    return firstSuccessful(rpcs.map(async (rpc) => {
        await callback(rpc);
        return rpc;
    }));
};
export const formatToken = (token) => {
    const start = token?.slice(0, 4) ?? '';
    const end = token?.slice(-4) ?? '';
    return `${start}....${end}`;
};
export const formatElapsed = (ms) => {
    const totalSec = Math.floor(ms / 1000);
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    return m > 0 ? `${m}:${s.toString().padStart(2, '0')}` : `${s}s`;
};
export const formatImageURL = (url) => {
    return url.startsWith('images') || url.startsWith('./images')
        ? `${process.env.REACT_APP_BASE_URL}/${url}`
        : url;
};
/** Axios / fetch-style API errors: response.data message, validation arrays, etc. */
function extractApiErrorMessage(error) {
    const d = error?.response?.data;
    if (d == null)
        return undefined;
    if (typeof d === 'string' && d.trim())
        return d.trim();
    if (typeof d !== 'object')
        return undefined;
    const payload = d;
    if (typeof payload.message === 'string' && payload.message.trim())
        return payload.message.trim();
    if (Array.isArray(payload.message)) {
        const parts = payload.message
            .map((m) => (typeof m === 'string' ? m : (m?.message ?? m?.msg)))
            .filter(Boolean);
        if (parts.length)
            return parts.join(', ');
    }
    if (typeof payload.error === 'string' && payload.error.trim())
        return payload.error.trim();
    if (Array.isArray(payload.errors)) {
        const parts = payload.errors
            .map((e) => typeof e === 'string'
            ? e
            : (e?.msg ??
                e.message ??
                String(e)))
            .filter(Boolean);
        if (parts.length)
            return parts.join('; ');
    }
    if (payload.errors && typeof payload.errors === 'object' && !Array.isArray(payload.errors)) {
        const parts = Object.values(payload.errors)
            .flatMap((v) => (Array.isArray(v) ? v : [v]))
            .map((v) => typeof v === 'string'
            ? v
            : (v?.message ?? v.msg))
            .filter(Boolean);
        if (parts.length)
            return parts.join('; ');
    }
    return undefined;
}
export const translateErrorMessage = (error) => {
    if (error == null)
        return 'Unknown error';
    const apiMsg = extractApiErrorMessage(error);
    if (apiMsg)
        return apiMsg;
    const err = error;
    if (err.action == 'estimateGas') {
        return 'Please check your balance and try again.';
    }
    else if (err.action == 'call' && err.transaction && err.code == 'CALL_EXCEPTION') {
        return 'The transaction is failed to execute.';
    }
    else if (err.action == 'sendTransaction' || `${error}`.includes('WalletSignTransactionError')) {
        if (err.reason == 'rejected' || `${error}`.includes('WalletSignTransactionError')) {
            return 'The transaction is rejected.';
        }
        console.log(error);
        return 'Sending transaction is failed.';
    }
    else if ((err.message ?? '').includes('wallet_requestPermissions')) {
        return err.message ?? 'Unknown error';
    }
    else if (err.code == 'SERVER_ERROR') {
        if (err.info?.responseStatus?.trim() == '500') {
            if (`${error}`.includes('Batch of more than 3 requests are not allowed on free tier')) {
                return 'Please upgrade your API plan to support more requests.';
            }
        }
        else if (err.info?.responseStatus?.trim() == '402') {
            if (`${error}`.includes('Batch calls are available for paid plans only.')) {
                return 'Please upgrade your API plan to support more requests.';
            }
        }
        return 'Server error, please try again later.';
    }
    else if (err.code == 'ERR_NETWORK') {
        return err.message || 'Network error, please check your connection.';
    }
    else if (err.code == 'UNKNOWN_ERROR') {
        return `${error}`;
    }
    else if (err.code == 'BAD_DATA') {
        return `${err.message}`;
    }
    else {
        const strError = `${error}`;
        if (strError.startsWith('TypeError: invalid FixedNumber string value')) {
            return 'Invalid number format.';
        }
        else if (strError.startsWith('TypeError: Failed to fetch')) {
            return 'Network error, please check your connection.';
        }
        else if (strError.includes('Too many request')) {
            return 'Too many requests, please try again later.';
        }
        else if (strError.includes('User rejected the request.') ||
            strError.includes('4100') ||
            strError.includes('has not been authorized')) {
            return 'The signature request was rejected.';
        }
        console.log('Unknown Error', error);
        if (typeof err.message === 'string' && err.message.trim()) {
            return err.message.trim();
        }
        return strError;
    }
};
export function isNumericString(s) {
    if (typeof s !== 'string')
        return false;
    const str = s.trim();
    if (str.length === 0)
        return false;
    return /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(str);
}
